/**
 * Breadcrumb Dropdown Toggle
 */

class BreadcrumbDropdown {
    constructor(element) {
        this.dropdown = element;
        this.toggle = element.querySelector('.breadcrumb__dropdown-toggle');
        this.menu = element.querySelector('.breadcrumb__dropdown-menu');

        if (!this.toggle || !this.menu) return;

        this.init();
    }

    init() {
        this.toggle.addEventListener('click', () => this.toggleMenu());

        document.addEventListener('click', (e) => {
            if (!this.dropdown.contains(e.target)) {
                this.closeMenu();
            }
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.isOpen()) {
                this.closeMenu();
                this.toggle.focus();
            }
        });

        const links = this.menu.querySelectorAll('.breadcrumb__dropdown-link');
        links.forEach(link => {
            link.addEventListener('click', () => {
                this.closeMenu();
            });
        });
    }

    toggleMenu() {
        if (this.isOpen()) {
            this.closeMenu();
        } else {
            this.openMenu();
        }
    }

    openMenu() {
        this.toggle.setAttribute('aria-expanded', 'true');
        this.menu.removeAttribute('hidden');
    }

    closeMenu() {
        this.toggle.setAttribute('aria-expanded', 'false');
        this.menu.setAttribute('hidden', '');
    }

    isOpen() {
        return this.toggle.getAttribute('aria-expanded') === 'true';
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const dropdowns = document.querySelectorAll('.breadcrumb__dropdown');
    dropdowns.forEach(dropdown => new BreadcrumbDropdown(dropdown));
});

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
        const dropdowns = document.querySelectorAll('.breadcrumb__dropdown');
        dropdowns.forEach(dropdown => new BreadcrumbDropdown(dropdown));
    });
}